<div
  class="group relative flex cursor-pointer flex-col items-center rounded-md border border-grey-lightGrey px-2 py-4 hover:shadow-sm"
  [ngClass]="sizeClasses()"
  appDragOver
  *transloco="let t"
>
  <input
    #fileInput
    type="file"
    class="absolute inset-0 size-full cursor-pointer opacity-0"
    (change)="onFileSelected()"
    [accept]="acceptedFile()"
  />
  <button class="size-8 rounded-full bg-grey-veryLightGrey">
    <mat-icon
      class="material-symbols-outlined !inline-flex place-content-center text-base text-grey group-hover:text-blue"
    >
      {{ icon() }}
    </mat-icon>
  </button>
  <div class="justify-center text-center">
    <app-text-button (click)="fileInput.click()">{{
      t('general.fileUpload.uploadButtonText')
    }}</app-text-button>
    <span class="text-sm font-normal">
      {{ t('general.fileUpload.uploadButtonDescription') }}</span
    >
  </div>
  <div class="text-[10px] font-medium text-grey">
    <ng-content></ng-content>
  </div>
</div>
